import { isString } from 'core_main/globals/helpers';
import { GetConversationsParameters } from 'core_main/sdk/get_conversations/types';
import { getMappedLanguage } from 'i18n/helpers';
import {
  CREATE_CHAT_SESSIONS_ENDPOINT,
  CHAT_SESSIONS_ENDPOINT,
  CHAT_SESSION_ENDPOINT,
  CHAT_SESSION_MESSAGES_ENDPOINT,
  CHAT_SESSION_READ_ENDPOINT,
} from './constants';
import { CreateSessionParameters } from './types';

export const validateSessionParams = (sessionId: string) => {
  if (!sessionId) {
    return new Error('A conversationId must be provided.');
  }

  return undefined;
};

export const validateCreateSessionParams = (
  parameters: CreateSessionParameters,
) => {
  const title = parameters?.title;

  if (title && isString(title) && title.length > 256) {
    return new Error('Title must be less than or equal to 256 characters');
  }

  return undefined;
};

export const makeGetChatSessionsEndpoint = (
  parameters: GetConversationsParameters,
) => {
  const page = parameters?.page;
  const pageSize = parameters?.pageSize;
  const brandId = parameters?.brandId;

  const queryParams = new URLSearchParams();

  if (page) {
    queryParams.set('page', String(page));
  }

  if (pageSize) {
    queryParams.set('pageSize', String(pageSize));
  }

  if (brandId) {
    queryParams.set('brandId', brandId);
  }

  const serializedQueryParams = queryParams.toString();
  if (serializedQueryParams) {
    return `/c/v2/chat/sessions?${serializedQueryParams}` as typeof CHAT_SESSIONS_ENDPOINT;
  }

  return CHAT_SESSIONS_ENDPOINT;
};

export const makeChatSessionEndpoint = (id: string) => {
  return `/c/v2/chat/sessions/${id}` as typeof CHAT_SESSION_ENDPOINT;
};

export const makeChatSessionMessagesEndpoint = (parameters) => {
  const sessionId = parameters?.sessionId;
  const messageIds = parameters?.messageIds;

  return `/c/v2/chat/sessions/${sessionId}/messages/${messageIds}` as typeof CHAT_SESSION_MESSAGES_ENDPOINT;
};

export const makeCreateChatSessionEndpoint = (parameters) => {
  const lang = parameters?.lang;

  const mappedLang = getMappedLanguage(lang);

  if (mappedLang) {
    return `/c/v2.1/chat/sessions?lang=${mappedLang}` as typeof CREATE_CHAT_SESSIONS_ENDPOINT;
  }

  return `/c/v2.1/chat/sessions` as typeof CREATE_CHAT_SESSIONS_ENDPOINT;
};

export const makeChatSessionReadEndpoint = (sessionId: string) => {
  return `/c/v2/chat/sessions/${sessionId}/markAsRead` as typeof CHAT_SESSION_READ_ENDPOINT;
};
